<div class="highlighted-container container">
    <div class="row">
        <div class="highlighted">  
            <div class="region region-highlighted">
                <h1 class="page-header">
                    <span>{{ 'REQUEST_ACCOUNT_VALIDATION_HEADING' | translate }}</span>
                </h1>
            </div>
        </div>
    </div>
</div>

<div class="main-container container">
    <div class="row">
        <section class="col-sm-2"></section>
        <section class="col-sm-8">
            <div class="region region-content">
                <p> {{ 'REQUEST_ACCOUNT_VALIDATION_NOTICE1' | translate }}
                    <a routerLink="/request-status">{{ "REQUEST_ACCOUNT_VALIDATION_NOTICE2" | translate }}</a>
                </p>
                <form class="custom-from" #customForm="ngForm" (ngSubmit)="submitForm(customForm)" novalidate>
                    <p class="subtitle">{{ 'REQUEST_ACCOUNT_VALIDATION_TITLE1' | translate }}</p>
                    <div class="row">
                        <section class="col-sm-6 lb"><label class="star">*</label>{{ 'REQUEST_ACCOUNT_VALIDATION_INPUT_LASTNAME' | translate }}</section>
                        <section class="col-sm-6">
                            <input type="text" 
                                class="form-control" 
                                id="lastName" name="lastName" 
                                [(ngModel)]="customer.lastName"   
                                [ngClass]="{ 'is-invalid': formSubmitted && customForm.controls.lastName.errors }"
                                placeholder="{{ 'COMMON_LBL_REQUIRED' | translate }}"                                            
                                required maxlength="100"/>
                        </section>
                        <section class="col-sm-6 lb">{{ 'REQUEST_ACCOUNT_VALIDATION_INPUT_FIRSTNAME' | translate }}</section>
                        <section class="col-sm-6">
                            <input type="text" 
                                class="form-control" 
                                id="firstName" name="firstName" 
                                [(ngModel)]="customer.firstName"                   
                                maxlength="100"/>
                        </section>
                        <section class="col-sm-6 lb"><label class="star">*</label>{{ 'REQUEST_ACCOUNT_VALIDATION_INPUT_POSTALCODE' | translate }}</section>
                        <section class="col-sm-6">                        
                            <input type="text" 
                                class="form-control" 
                                id="postalCode" name="postalCode" 
                                [(ngModel)]="customer.postalCode"   
                                [ngClass]="{ 'is-invalid': formSubmitted && customForm.controls.postalCode.errors }"
                                placeholder="{{ 'COMMON_LBL_REQUIRED' | translate }}"                                              
                                (input)="postalCodeValidator($event)" 
                                [pattern]="postalcodePattern" required maxlength="6"/>
                        </section>
                        <section class="col-sm-6 lb"><label class="star">*</label>{{ 'REQUEST_ACCOUNT_VALIDATION_INPUT_PHONE' | translate }}</section>
                        <section class="col-sm-6">
                            <input type="text" 
                                class="form-control" 
                                id="phoneNumber" name="phoneNumber" 
                                [(ngModel)]="customer.phoneNumber"   
                                [ngClass]="{ 'is-invalid': formSubmitted && customForm.controls.phoneNumber.errors }"
                                placeholder="{{ 'COMMON_LBL_REQUIRED' | translate }}"                                              
                                (input)="phoneValidator($event)" 
                                [pattern]="phoneNumberPattern" required maxlength="10"/>
                        </section>
                        <section class="col-sm-6 lb"><label class="star">*</label>{{ 'REQUEST_ACCOUNT_VALIDATION_INPUT_EMAIL' | translate }}</section>
                        <section class="col-sm-6">
                            <input type="text" 
                                class="form-control" 
                                id="emailAddress" name="emailAddress" 
                                [(ngModel)]="customer.emailAddress"   
                                [ngClass]="{ 'is-invalid': formSubmitted && customForm.controls.emailAddress.errors }"
                                placeholder="{{ 'COMMON_LBL_REQUIRED' | translate }}"                                             
                                [pattern]="emailPattern" required maxlength="250"/>
                            <div *ngIf="formSubmitted && customForm.form.controls.emailAddress.invalid" class="text-danger">
                                <div *ngIf="customForm.form.controls.emailAddress.errors.pattern">{{ 'REQUEST_ACCOUNT_VALIDATION_ERR_EMAIL_INVALID' | translate }}</div>
                            </div>
                        </section>
                    </div>
                    <p class="subtitle">{{ 'REQUEST_ACCOUNT_VALIDATION_TITLE2' | translate }}</p>
                    <div class="row">
                        <section class="col-sm-6 lb">{{ 'REQUEST_ACCOUNT_VALIDATION_INPUT_VIN' | translate }}</section>
                        <section class="col-sm-6">                        
                            <input type="text" 
                                class="form-control" 
                                id="serialNumber" name="serialNumber" 
                                [(ngModel)]="customer.serialNumber"   
                                [ngClass]="{ 'is-invalid': formSubmitted && (customForm.controls.serialNumber.errors || (customer.serialNumber=='' && customer.accountNumber=='' && (customer.paymentAmount==undefined || customer.paymentAmount==''))) }"
                                placeholder="{{ 'REQUEST_ACCOUNT_VALIDATION_PH_VIN' | translate }}"                                                
                                [pattern]="vinPattern" maxlength="17"/>
                        </section>
                        <section class="col-sm-6 lb">{{ 'REQUEST_ACCOUNT_VALIDATION_INPUT_LEASE_NUM' | translate }}</section>
                        <section class="col-sm-6">                        
                            <input type="text" 
                                class="form-control" 
                                id="accountNumber" name="accountNumber" 
                                [(ngModel)]="customer.accountNumber"   
                                [ngClass]="{ 'is-invalid': formSubmitted && (customForm.controls.accountNumber.errors || (customer.serialNumber=='' && customer.accountNumber=='' && (customer.paymentAmount==undefined || customer.paymentAmount==''))) }"
                                placeholder="{{ 'REQUEST_ACCOUNT_VALIDATION_PH_LEASE_NUM' | translate }}"                                                
                                [pattern]="accountNumberPattern" maxlength="10"/>
                        </section>
                        <section class="col-sm-6 lb">{{ 'REQUEST_ACCOUNT_VALIDATION_INPUT_PAYMENT_AMT' | translate }}</section>
                        <section class="col-sm-6">                        
                            <input type="text" 
                                class="form-control" 
                                id="paymentAmount" name="paymentAmount" 
                                [(ngModel)]="customer.paymentAmount"   
                                [ngClass]="{ 'is-invalid': formSubmitted && (customForm.controls.paymentAmount.errors || (customer.serialNumber=='' && customer.accountNumber=='' && (customer.paymentAmount==undefined || customer.paymentAmount==''))) }"
                                [pattern]="paymentAmountPattern" maxlength="10"/>
                        </section>                        
                    </div>
                    <div *ngIf="formSubmitted && (customForm.invalid || (customer.serialNumber=='' && customer.accountNumber=='' && (customer.paymentAmount==undefined || customer.paymentAmount=='')))" class="row" style="margin: auto;">
                        <div class="col-sm-12 error-note">
                            <label translate="COMMON_LBL_FORM_ERR_NOTE"></label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6"></div>
                        <div class="col-md-6">
                            <button type="submit" class="btn btn-secondary action-row">{{ 'COMMON_BTN_SUBMIT' | translate }}</button>
                        </div>
                    </div>
                </form>
            </div>
        </section>
        <section class="col-sm-2"></section>
    </div>
</div>